module.exports = __webpack_public_path__ + "static/media/template_order.9472aae0.csv";